import { ReactElement } from 'react'

export default function Footer(): ReactElement {
  return (
    <footer className="bg-background border-t border-border mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <p className="text-center text-sm text-muted-foreground">
          &copy; {new Date().getFullYear()} MNTND. All rights reserved.
        </p>
      </div>
    </footer>
  )
}
